import React from "react";
import styles from "./InTaxSummaryCard.module.css";
// later: import { calcExpectedTax } from "../utils/calcExpectedTax";

export default function InTaxSummaryCard({ year, jurisdiction, summary }) {
  // Placeholder expected tax; later compute with calcExpectedTax + config
  const expected = summary.expectedYtdTax ?? 0;
  const delta = expected - (summary.ytdTaxWithheld || 0);
  const deltaClass = delta > 0 ? "negative" : delta < 0 ? "positive" : "";

  return (
    <div className={`card ${styles.card}`}>
      <div className="card-body">
        <div className="d-flex align-items-start justify-content-between">
          <div>
            <h2 className="h5 mb-1">Summary · {year}</h2>
            <div className="text-secondary small">
              Uses current brackets for your jurisdiction; not tax advice.
            </div>
          </div>
          <span className="badge bg-light text-dark border">
            {jurisdiction.countryCode.toUpperCase()} · {jurisdiction.provinceOrState.toUpperCase()}
          </span>
        </div>

        <div className="row g-3 mt-2">
          <KPI label="YTD Gross" value={summary.ytdGross} />
          <KPI label="Taxes Withheld (YTD)" value={summary.ytdTaxWithheld} />
          <KPI label="Expected Tax (YTD)" value={expected} />
          <KPI
            label="Refund/Owe (YTD)"
            value={Math.abs(delta)}
            valueClass={deltaClass}
            hint={delta > 0 ? "You may owe" : delta < 0 ? "Refund likely" : "Even"}
          />
        </div>
      </div>
    </div>
  );
}

function KPI({ label, value = 0, valueClass = "", hint }) {
  const fmt = new Intl.NumberFormat(undefined, { style: "currency", currency: "CAD" }).format;
  return (
    <div className="col-12 col-md-6 col-xl-3">
      <div className={`p-3 border rounded-3 bg-body ${styles.kpi}`}>
        <div className="text-secondary small">{label}</div>
        <div className={`h5 mb-0 mt-1 amount ${valueClass}`}>{fmt(value)}</div>
        {hint && <div className="small text-secondary mt-1">{hint}</div>}
      </div>
    </div>
  );
}
